import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import cls from './ValueCard.module.css';
import { getFromLocalStorage } from '../../../../shared/helpers/localStorageHandler';
import { measurementsSelector } from '../../../../store/slices/measurementsSlice/measurementsSlice';

export const ValueCard = ({ value, units, title, type, dimensionId }) => {
    const [wereChange, setWereChange] = useState(null);
    const measurementsIds = useSelector(measurementsSelector.selectIds);

    useEffect(() => {
        const valueBlock = document.querySelector('.bulk-action-bar');
        const valueOperation = document.querySelector('.modal.modalable-popup.show');
        const valueBlockStyle = window.getComputedStyle(valueBlock);

        if (valueBlockStyle.getPropertyValue('display') === 'none' && valueOperation === null) {
            setWereChange('editorEstimate');
        } else if (valueOperation !== null) {
            setWereChange('editorOperation');
        } else if (valueBlockStyle.getPropertyValue('display') !== 'none') {
            setWereChange('massEditEstimate');
        }
    }, []);

    const onClickValue = () => {
        const localId = getFromLocalStorage('idMeasurement');
        const firstId = measurementsIds[0];
        const currentId = measurementsIds.includes(localId) ? localId : firstId;

        if (wereChange === 'editorEstimate') {
            document.querySelectorAll('.table-row.position').forEach((element) => {
                const reactIcon = element.querySelector('.table-column.react-icon');
                const amount = element.querySelector('.table-column.amount');
                if (reactIcon && reactIcon.classList.contains('activeIcon')) {
                    const position = element.closest('.position');
                    const $position = $(position);
                    const prevAmount = PM.getAmount($position);
                    const prevUnit = $(position).find('.table-column.unit').text();
                    if (element.classList.contains('group')) {
                        const undoAction = {
                            type: 'single',
                            action: 'addGroupMeasurementsValue',
                            positions: [{ prevAmount, prevUnit, element: $position }],
                        };
                        MyApp.store.dispatch(MyApp.actions.estimateUndo.addUndoAction(undoAction));

                        PM.setAmount(position, value);
                        PM.setUnit(position, units);
                        PM.updateGroupAmount(amount, false, null, true);
                        PM.updateUnit(position, false, true);
                        PM.setConnectionLink(position, {
                            id: currentId,
                            value: type,
                            dimensionId,
                        });
                    } else {
                        const undoAction = {
                            type: 'single',
                            action: 'addMeasurementsValue',
                            positions: [{ prevAmount, prevUnit, element: $position }],
                        };
                        MyApp.store.dispatch(MyApp.actions.estimateUndo.addUndoAction(undoAction));

                        PM.setAmount(position, value);
                        PM.setUnit(position, units);
                        PM.updateAmount(position, false, true);
                        PM.updateUnit(position, false, true);
                        PM.setConnectionLink(position, {
                            id: currentId,
                            value: type,
                            dimensionId,
                        });
                    }

                    reactIcon.click();
                }
            });
        }
        if (wereChange === 'editorOperation') {
            const valueOperation = document.querySelector('.modal.modalable-popup.show');
            const input = valueOperation.querySelector('input');
            input.value = value;
            input.setAttribute('data-units', units);
            input.setAttribute('data-measurementId', currentId);
            input.setAttribute('data-measurementType', type);
            input.setAttribute('data-dimensionId', dimensionId);

            const reactDiv = document.querySelector('#react-estimateMeasurements');
            if (reactDiv) {
                reactDiv.remove();
            }
        }
        if (wereChange === 'massEditEstimate') {
            // positionMassEditManager.newMassChangeAmount(value);
            // positionMassEditManager.newMassChangeUnit(units);
            positionMassEditManager.newMassChangeValueFromMeasurement({
                amount: value,
                unit: units,
                id: currentId,
                value: type,
                dimensionId,
            });
            const reactDiv = document.querySelector('#react-estimateMeasurements');
            if (reactDiv) {
                reactDiv.remove();
            }
        }
    };
    return (
        <div className={cls.container} onClick={onClickValue}>
            <span className={cls.ValueName}>{title}</span>
            <span className={cls.ValueNumber}>
                {value} {units}
            </span>
        </div>
    );
};
